/**
 * K2D w_specdim: a speciális dimenzió Tól/Ig intervallum-szűrő értéke
 * (1=Munkaszám, 2=Gépjármű, 3=Szerelő, 4=Szerviztípus).
 * A SpecialDimensionFilterButton v-modellje.
 */
export default interface SpecialDimensionFilterValue {
  from1: string;
  to1: string;
  from2: string;
  to2: string;
  from3: string;
  to3: string;
  from4: string;
  to4: string;
}

export function emptySpecialDimensionFilter(): SpecialDimensionFilterValue {
  return { from1: "", to1: "", from2: "", to2: "", from3: "", to3: "", from4: "", to4: "" };
}
